import React from 'react';
import { Location } from 'history';

import { useServices } from 'ha/services';
import { StudentenWG, Zwischenmitte, Rentmate, StanzaZoo } from './constants';

export function useKrugerNotification(location: Location) {
  const utmSource: string = location.query.utm_source;

  const {
    cookie: { getCookie, setCookie },
  } = useServices();
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    const cookie = getCookie('kruger_visited');

    if (
      cookie !== '1' &&
      [StudentenWG, Zwischenmitte, Rentmate, StanzaZoo].includes(utmSource)
    ) {
      setOpen(true);
    }
  }, []);

  const handleClose = React.useCallback(() => {
    setCookie('kruger_visited', '1');
    setOpen(false);
  }, []);

  return {
    open,
    handleClose,
    utmSource,
  };
}
